export interface RoomSegmentCounts {
  baseOnly: number;
  upgOnly: number;
  soloBase: number;
  soloUpg: number;
}

export function computePackageSegmentation(
  packages: number,
  upgradeRatePct: number,
  soloRatePct: number,
  soloUpgradeRatePct: number,
): RoomSegmentCounts {
  const upgradeRate = upgradeRatePct / 100;

  const upgrade = Math.round(packages * upgradeRate);
  const solo = Math.round(packages * (soloRatePct / 100));
  const soloUpg = Math.round(solo * (soloUpgradeRatePct / 100));
  const soloBase = solo - soloUpg;

  return {
    baseOnly: packages - upgrade - soloBase,
    upgOnly: upgrade - soloUpg,
    soloBase,
    soloUpg,
  };
}
